import React, { useState, useEffect, useRef } from "react";
import "NOTICEBOARD/Components/Reports/DeprtmentNoticeCount/departmentnoticecount.css";
import NoticeboardAPICall from "NoticeboardAPICall";
import config from "config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "NOTICEBOARD/CommonResources/SpinnerLoader/Spinner";
import { useReactToPrint } from "react-to-print";
import ReactHtmlParser from "react-html-parser";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Pagination from "react-js-pagination";
import ButtonLoader from "NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader";
// import GoogleLogin from 'Post Notice';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import { Base64 } from "js-base64";

function SemesterNoticeList() {
    const [academicYearList, setAcademicYearList] = useState({});
    const [departmentList, setDepartmentList] = useState({});
    const [groupList, setGroupList] = useState({});
    const [categoryList, setCategoryList] = useState({});
    const [filterAcademicYear, setFilterAcademicYear] = useState("");
    const [filterDepartment, setFilterDepartment] = useState("");
    const [filterGroup, setFilterGroup] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [filterCategory, setFilterCategory] = useState("");
    const [url, setUrl] = useState("");
    const [fetchingReport, setFetchingReport] = useState(false);
    const [reportSequence, setReportSequence] = useState([]);
    const [reportDetails, setReportDetails] = useState({});
    const [reportCount, setReportCount] = useState("");
    const [filterApplied, setFilterApplied] = useState(false);
    const [exportAllConfirmation, setExportAllConfirmation] = useState(false);
    const [exportAllApiProgress, setExportAllApiProgress] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [pagination, setPagination] = useState({
        pageIndex: 1,
        limit: 10,
        offset: 0,
    });
    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });
    const CLIENT_ID = "1051565806657-s1an6r32ecti5o4ogrp2q1uhhpkgjffk.apps.googleusercontent.com";

    const [filterDisplay, setFilterDisplay] = useState(true);
    const [visibility, setVisibility] = useState([
        { name: "Title", visibility: true },
        { name: "Category", visibility: true },
        { name: "Notice Id", visibility: true },
        { name: "Department", visibility: true },
        { name: "Year", visibility: true },
        { name: "Posted By", visibility: true },
        { name: "Notice Date & Time", visibility: true },
        { name: "To be Viewed by", visibility: true },
        { name: "Viewed by", visibility: true },
    ]);

    const componentRef = useRef();

    useEffect(() => {
        apiCallToGetAcademicYearList();
    }, []);

    useEffect(() => {
        apiCallToGetDepartmentList();
    }, []);

    useEffect(() => {
        if (filterAcademicYear != "" && filterDepartment != "") {
            apiCallToGetGroupList();
        }
    }, [filterAcademicYear, filterDepartment]);

    useEffect(() => {
        apiCallToGetCategoryList();
    }, []);

    useEffect(() => {
        apiCallToGetReportList();
    }, [pagination]);


    const apiCallToGetUploadURL = async () => {
        setUploading(true);

        const post_request = {
            iid: config.institute_id,
            userId: config.faculty_id,
            module_id: 42,
            userRole: config.userRole == "teaching" ? "instructor" : config.userRole,
            request_key: "Semester_wise_Notice_List_Report",
            reference_unique_id: "",
            page_index: pagination.pageIndex,
            limit: pagination.limit,
            academicYearId: filterAcademicYear,
            sid: filterDepartment,
            groupIdArray: filterGroup,
            filter_category: filterCategory,
        }

        const requestData = {
            // userId: 1803,
            userId: config.faculty_id,
            userRole: config.userRole == "teaching" ? "instructor" : config.userRole,
            module_id: 42,
            request_key: "Semester_wise_Notice_List_Report",
            reference_unique_id: "",
            post_request: Base64.encode(JSON.stringify(post_request))
        }

        const jsonResponse = await NoticeboardAPICall.makeApiCall(
            "googleDriveIntegration",
            requestData,
            "/api/integration/googleDriveIntegration.php"
        );


        if (jsonResponse.expired) {
            setTimeout(() => apiCallToGetUploadURL(), 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status == "success") {
                  
                    if(jsonResponse.APIResult.link.length == 0)
                    {
                        setSuccessModalDetails({
                            successModal: true,
                            successModalType: "success",
                            successMessage: jsonResponse.APIResult.message,
                        });
                    }else{

                        setUrl(jsonResponse.APIResult.link)
                        window.open(jsonResponse.APIResult.link, '_blank');
                    }
                    // Redirect to the obtained URL
                } else {
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: "warning",
                        successMessage: 'Record already exists.'
                    });
                }
                setUploading(false);
            } else {
                setSuccessModalDetails({
                    successModal: true,
                    successModalType: "warning",
                    successMessage: 'Something went wrong, Please try again later ...'
                });
                setUploading(false);
            }
        }
    }

    // API CALL METHOD TO GET ACADEMIC YEAR LIST
    const apiCallToGetAcademicYearList = async () => {
        let formData = {
            iid: config.institute_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetAcademicYearListObject",
            formData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if(Object.keys(apiResult).length > 0 && jsonResponse.APIResult.sortedIdArray.length > 0) 
                {
                    jsonResponse.APIResult.sortedIdArray.map(yearId => {
                        apiResult[yearId]['yearId'] = yearId;
                    });
                }
                setAcademicYearList(apiResult);
            }
        }
    };

    // API CALL MElimitTHOD TO GET DEPARTMENT LIST
    const apiCallToGetDepartmentList = async () => {
        let formData = {
            iid: config.institute_id,
            sidArray: [],
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetInstituteStreamsObject",
            formData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetDepartmentList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = await jsonResponse.APIResult.data;
                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map((streamId) => {
                        apiResult[streamId]["departmentId"] = streamId;
                    });
                }

                setDepartmentList(apiResult);
            }
        }
    };

    // API CALL METHOD TO GET CATEGORY LIST
    const apiCallToGetCategoryList = async () => {
        let formData = {
            iid: config.institute_id,
            offset: "",
            limit: "",
            filterCategoryName: "",
            filterStatus: "",
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetNoticeBoardCategoryList",
            formData,
            "/api/notice/category.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetCategoryList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map((categoryId) => {
                        apiResult[categoryId]["categoryId"] = categoryId;
                    });
                }
                setCategoryList(apiResult);
            }
        }
    };

    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        });
    }

    // METHOD TO SELECT ACADEMIC YEAR
    const selectAcademicYear = (e) => {
        if (e.target.value.length < 1) {
            setGroupList({});
            setFilterGroup([]);
            setSelectedGroup([]);
        }

        setFilterAcademicYear(e.target.value);
    };

    // METHOD TO SELECT DEPARTMENT
    const selectDepartment = (e) => {
        if (e.target.value.length < 1) {
            setGroupList({});
            setFilterGroup([]);
            setSelectedGroup([]);
        }

        setFilterDepartment(e.target.value);
    };

    // API CALL METHOD TO GET GROUP LIST
    const apiCallToGetGroupList = async () => {
        let requestData = {
            iid: config.institute_id,
            sidArray: [filterDepartment],
            academicIdArray: [filterAcademicYear],
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "GetGroupList",
            requestData,
            "/api/admission/groupDetails.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetGroupList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map((groupId) => {
                        apiResult[groupId]["groupId"] = groupId;
                    });
                }
                setGroupList(apiResult);
            }
        }
    };

    // METHOD TO SELECT GROUP
    const selectGroup = (group) => {
        let filterGroupDetails = filterGroup;
        let selectedGroupDetails = selectedGroup;

        if (filterGroup.includes(group.groupId)) {
            filterGroupDetails = filterGroupDetails.filter(
                (id) => id != group.groupId
            );
            selectedGroupDetails = selectedGroupDetails.filter(
                (id) => id != group.groupName
            );
        } else {
            filterGroupDetails.push(group.groupId);
            selectedGroupDetails.push(group.groupName);
        }

        setFilterGroup([...filterGroupDetails]);
        setSelectedGroup([...selectedGroupDetails]);
    };

    // METHOD TO APPLY FILTER
    const applyFilter = () => {
        setFilterApplied(true);
        apiCallToGetReportList();
    };

    // API CALL METHOD TO GET NOTICE COUNT DETAILS
    const apiCallToGetReportList = async () => {
        setFetchingReport(true);
        let requestData = {
            institute_id: config.institute_id,
            page_index: pagination.pageIndex,
            limit: pagination.limit,
            academicYearId: filterAcademicYear,
            sid: filterDepartment,
            groupIdArray: filterGroup,
            filter_category: filterCategory,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getSemesterWiseNoticeList",
            requestData,
            "/api/notice/notice.php"
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetReportList();
            }, 1000);
        } else {
            if (jsonResponse.success) 
            {
                let apiResult = jsonResponse.APIResult.data;
                setReportSequence(jsonResponse.APIResult.sequenceIdArray);
                setReportDetails(apiResult);
                setFetchingReport(false);
                setReportCount(jsonResponse.APIResult.totalCount);
            }
        }
    };

    // METHOD TO CLEAR FILTER
    const clearFilter = () => {
        setFilterAcademicYear("");
        setFilterDepartment("");
        setFilterGroup([]);
        setSelectedGroup([]);
        setFilterCategory("");
        setFilterApplied(false);
        setPagination({
            limit: 10,
            offset: 0,
            pageIndex: 1,
        });
    };

    // METHOD TO UPDATE COLUMN DISPLAY
    const updateColumnDisplay = (index) => {
        let visibilityDetails = visibility;

        visibilityDetails[index].visibility =
            !visibilityDetails[index].visibility;

        setVisibility([...visibilityDetails]);
    };

    // METHOD TO PRINT REPORT
    const printReport = useReactToPrint({
        content: () => componentRef.current,
    });

    // METHOD TO EXPORT REPORT
    const exportReport = () => {
        document.getElementById("exportReport").click();
    };

    // METHOD TO RETURN REPORT TABLE COMPONENT
    const ReportTable = React.forwardRef((props, ref) => {
        return (
            <div className='mainDataContainer'>
                <div className='report-container' ref={componentRef}>
                    <div className='college-info'>
                        <img
                            className='report-college-logo'
                            alt='college-logo'
                            src={config.instructorInfo.InstituteLogo}
                        />
                        <p className='report-college-name'>
                            {ReactHtmlParser(config.institute_full_name)}
                        </p>
                    </div>
                    <div className='report-name-print col-md-12'>
                        Semester wise Notice List Report
                    </div>
                    <div className='col-md-12 reportDetails-container'>
                        <table
                            className='table table-bordered table-fixed'
                            id='countTable'
                            style={{ backgroundColor: "#FFF" }}>
                            <thead>
                                <tr style={{ display: "none" }}>
                                    <th
                                        style={{ padding: 5 }}
                                        colSpan={visibility.length + 1}>
                                        {ReactHtmlParser(
                                            config.institute_full_name
                                        )}
                                    </th>
                                </tr>
                                <tr>
                                    <th
                                        style={{
                                            padding: 5,
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                        }}>
                                        Sr. No.
                                    </th>
                                    {visibility.map((header) => {
                                        if (header.visibility) {
                                            return (
                                                <th
                                                    style={{
                                                        padding: 5,
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word",
                                                    }}>
                                                    {header.name}
                                                </th>
                                            );
                                        }
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {fetchingReport ? (
                                    <tr>
                                        <th style={{ padding: 5 }} colSpan={9}>
                                            <ButtonLoader />
                                        </th>
                                    </tr>
                                ) : Object.keys(reportDetails).length > 0 ? (
                                    reportSequence.map(
                                        (noticeId, noticeIndex) => {
                                            let notice =
                                                reportDetails[noticeId];
                                            return (
                                                <tr key={notice.noticeId}>
                                                    <td
                                                        style={{
                                                            padding: 5,
                                                            whiteSpace:
                                                                "normal",
                                                            wordBreak:
                                                                "break-word",
                                                        }}>
                                                        {pagination.offset +
                                                            noticeIndex +
                                                            1}
                                                        .
                                                    </td>
                                                    {visibility[0]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {notice.title}
                                                            </td>
                                                        )}
                                                    {visibility[1]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {
                                                                    notice.categoryName
                                                                }
                                                            </td>
                                                        )}
                                                        {visibility[2]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {notice.categorySeries.length > 0 && `${notice.categorySeries}-${notice.categoryNumber}`}
                                                            </td>
                                                        )}
                                                    {visibility[3]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {notice.department}
                                                            </td>
                                                        )}
                                                    {visibility[4]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {
                                                                    notice.academicYear
                                                                }
                                                            </td>
                                                        )}
                                                    {visibility[5]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {notice.addedBy}
                                                            </td>
                                                        )}
                                                    {visibility[6]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {
                                                                    notice.formattedNoticeDate
                                                                }
                                                            </td>
                                                        )}
                                                    {visibility[7]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {
                                                                    notice.assigneeCount
                                                                }
                                                            </td>
                                                        )}
                                                    {visibility[8]
                                                        .visibility && (
                                                            <td
                                                                style={{
                                                                    padding: 5,
                                                                    whiteSpace:
                                                                        "normal",
                                                                    wordBreak:
                                                                        "break-word",
                                                                }}>
                                                                {notice.totalViews}
                                                            </td>
                                                        )}
                                                </tr>
                                            );
                                        }
                                    )
                                ) : filterApplied ? (
                                    <tr>
                                        <td style={{ padding: 5 }} colSpan={9}>
                                            No notice list found as per applied
                                            filter.
                                        </td>
                                    </tr>
                                ) : (
                                    <tr>
                                        <td style={{ padding: 5 }} colSpan={9}>
                                            No notice list found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    });

	// METHOD TO REPORT PAGINATION COUNT
	const updateReportPagination = (pageNumber) => {
		setPagination(prev => ({
			...prev, 
            offset: (pageNumber - 1) * pagination.limit,
            pageIndex: pageNumber
		}));
	}

    // METHOD FOR SET SHOW RESULT
    const setShowResult = (e) => {
        setPagination({
            pageIndex: 1,
            limit: e.target.value,
            offset: 0
        });
    }

    // METHOD TO RETURN CHECK REGISTTAION STATUS
    const returnExportAllConfirmation = () => {
        return (
            <div className={exportAllConfirmation ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header selectFaculty-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'user-check']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Export All Responses</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => closeExportAllConfirmation()} />
                        </div>
                        <div className="modal-body selectFaculty-body">
                            <p>An Excel sheet will be created in Google Drive under the folder titled 'vmedulife'. Kindly confirm if you want to proceed.</p>
                        </div>
                        <div className="modal-footer selectFaculty-footer">
                            {/* <GoogleLogin
                                clientId={CLIENT_ID}
                                buttonText="Log In with Google"
                                onSuccess={responseGoogleSuccess}
                                onFailure={responseGoogleError}
                                isSignedIn={false}
                                cookiePolicy={"single_host_origin"}
                                className="googleLoginBtn"
                                accessType="offline"
                            /> */}
                            {/* <button className="btn primary-button" onClick={() => googleAuth()} disabled={exportAllApiProgress}>Confirm</button> */}
                            <button className="btn outline-button" disabled={uploading} onClick={() => apiCallToGetUploadURL()}>{uploading ? <ButtonLoader /> : "Confirm"}</button>
                            <button className="btn outline-button" disabled={uploading} onClick={() => closeExportAllConfirmation()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }




    // METHOD TO CLOSE REGISTRATION STATUS
    const closeExportAllConfirmation = () => {
        setExportAllConfirmation(false);
        setExportAllApiProgress(false);
        // this.setState({
        //     exportAllConfirmation: false,
        //     exportAllApiProgress: false
        // });
    }


    return (
        <>
            <div className='col-md-12'>
                <div className='filter-options'>
                    <div
                        className='filter-values col-md-6'
                        style={{ paddingLeft: 0 }}>
                        <button
                            className='btn outline-button'
                            onClick={() => setFilterDisplay(!filterDisplay)}>
                            <FontAwesomeIcon
                                icon={["fas", "filter"]}
                                style={{ marginRight: 5 }}
                            />
                            Filter
                        </button>
                    </div>
                    {Object.keys(reportDetails).length > 0 && !fetchingReport && (
                        <div
                            className='export-values col-md-6'
                            style={{ paddingRight: 0 }}>
                            <div style={{ display: "none" }}>
                                <ReactHTMLTableToExcel
                                    id='exportReport'
                                    className='download-table-xls-button btn btn-success mb-3'
                                    table='countTable'
                                    filename='Semester wise Notice List Report'
                                    sheet='tablexls'
                                    buttonText='Export'
                                />
                            </div>
                            {/* <div className="add-button dropdown">
                                <button className="btn addIntake-button" data-toggle="dropdown" title="Click to export responses">
                                    <FontAwesomeIcon className="viewGrievance-icon" style={{ cursor: 'pointer' }} color="#0465AC" icon={['fas', 'file-excel']} size="lg" />
                                </button>
                                <div className="dropdown-menu exportAllResponseMenu">
                                    <p className="addGroupItem" title="Click to export report" onClick={() => exportReport()}>Export</p>
                                    {
                                        (parseInt(config.institute_id) == 113 || parseInt(config.institute_id) == 106 || parseInt(config.institute_id) == 981) &&
                                        <p className="addGroupItem" title="Click to save all entries to google drive" onClick={() => setExportAllConfirmation(true)}>Export all entries to Google Drive</p>
                                    }
                                </div>
                            </div> */}
                            <button
                                className='btn outline-button filter-button'
                                onClick={() => exportReport()}>
                                <FontAwesomeIcon
                                    icon={["fas", "file-export"]}
                                    style={{marginRight: 5}}
                                />
                                Export
                            </button>
                            <button
                                className='btn outline-button filter-button'
                                onClick={() => printReport()}>
                                <FontAwesomeIcon
                                    icon={["fas", "print"]}
                                    style={{ marginRight: 5 }}
                                />
                                Print
                            </button>
                            <div className='setting-button'>
                                <div className='dropdown dropleft'>
                                    <FontAwesomeIcon
                                        className='reportFilter-icon'
                                        title='Click to select required columns in the report'
                                        data-toggle='dropdown'
                                        icon={["fas", "cog"]}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <div
                                        id='settingDropdown'
                                        className='dropdown-menu filterDropdownMenu'>
                                        {visibility.map((columnInfo, index) => {
                                            return (
                                                <p
                                                    className='dropdown-item'
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        padding: "5px 10px",
                                                    }}
                                                    key={columnInfo.name}
                                                    onClick={() =>
                                                        updateColumnDisplay(
                                                            index
                                                        )
                                                    }>
                                                    <input
                                                        type='checkbox'
                                                        style={{ marginRight: 5 }}
                                                        checked={
                                                            columnInfo.visibility
                                                        }
                                                    />
                                                    <span
                                                        style={{ fontSize: 14 }}>
                                                        {columnInfo.name}
                                                    </span>
                                                </p>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {filterDisplay && (
                    <div style={{ marginTop: 10 }} className='filter-container'>
                        <div className='filter-details'>
                            <div
                                className='academicYear'
                                style={{ width: "20%" }}>
                                <label
                                    style={{
                                        marginBottom: 0,
                                        fontSize: 14,
                                        fontWeight: "bold",
                                    }}>
                                    Academic Year
                                </label>
                                <select
                                    className='form-control filterReportInput'
                                    value={filterAcademicYear}
                                    onChange={(e) =>
                                        setFilterAcademicYear(e.target.value)
                                    }>
                                    <option value=''>
                                        Select Academic Year
                                    </option>
                                    {Object.keys(academicYearList).length > 0 &&
                                        Object.values(academicYearList).map(
                                            (year) => {
                                                return (
                                                    <option
                                                        key={year.yearId}
                                                        value={year.yearId}>
                                                        {year.year_text}
                                                    </option>
                                                );
                                            }
                                        )}
                                </select>
                            </div>
                            <div
                                className='departmentSelection'
                                style={{ width: "20%" }}>
                                <label
                                    style={{
                                        marginBottom: 0,
                                        fontSize: 14,
                                        fontWeight: "bold",
                                    }}>
                                    Department
                                </label>
                                <select
                                    className='form-control filterReportInput'
                                    value={filterDepartment}
                                    onChange={(e) => selectDepartment(e)}>
                                    <option value=''>Select Department</option>
                                    {Object.keys(departmentList).length > 0 &&
                                        Object.values(departmentList).map(
                                            (department) => {
                                                return (
                                                    <option
                                                        key={
                                                            department.departmentId
                                                        }
                                                        value={
                                                            department.departmentId
                                                        }>
                                                        {department.stream_name}
                                                    </option>
                                                );
                                            }
                                        )}
                                </select>
                            </div>
                            <div
                                className='groupSelection'
                                style={{ width: "20%" }}>
                                <label
                                    style={{
                                        marginBottom: 0,
                                        fontSize: 14,
                                        fontWeight: "bold",
                                    }}>
                                    Semester / Group
                                </label>
                                <div className='dropdown'>
                                    <input
                                        type='text'
                                        className='form-control filterReportInput'
                                        placeholder='Click to select semester / group'
                                        data-toggle='dropdown'
                                        readOnly
                                    />
                                    <div
                                        id='groupDropdown'
                                        className='dropdown-menu filterDropdownMenu'
                                        style={{ width: "100%" }}>
                                        {Object.keys(groupList).length > 0 ? (
                                            Object.values(groupList).map(
                                                (group) => {
                                                    return (
                                                        <p
                                                            className='dropdown-item'
                                                            style={{
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                padding:
                                                                    "5px 10px",
                                                            }}
                                                            key={group.groupId}
                                                            onClick={() =>
                                                                selectGroup(
                                                                    group
                                                                )
                                                            }>
                                                            <input
                                                                type='checkbox'
                                                                checked={filterGroup.includes(
                                                                    group.groupId
                                                                )}
                                                                style={{
                                                                    marginRight: 10,
                                                                }}
                                                            />
                                                            <span
                                                                style={{
                                                                    fontSize: 14,
                                                                }}>
                                                                {
                                                                    group.groupName
                                                                }
                                                            </span>
                                                        </p>
                                                    );
                                                }
                                            )
                                        ) : filterAcademicYear != "" &&
                                            filterDepartment != "" ? (
                                            <p
                                                style={{
                                                    color: "#818181",
                                                    fontSize: 12,
                                                }}>
                                                No group details found.
                                            </p>
                                        ) : (
                                            <p
                                                style={{
                                                    color: "#818181",
                                                    fontSize: 12,
                                                }}>
                                                Please select academic year and
                                                department to get group list.
                                            </p>
                                        )}
                                    </div>
                                    <p style={{ fontSize: 14 }}>
                                        {selectedGroup.join(", ")}
                                    </p>
                                </div>
                            </div>
                            <div
                                className='categorySelection'
                                style={{ width: "20%" }}>
                                <label
                                    style={{
                                        marginBottom: 0,
                                        fontSize: 14,
                                        fontWeight: "bold",
                                    }}>
                                    Category
                                </label>
                                <select
                                    className='form-control filterReportInput'
                                    value={filterCategory}
                                    onChange={(e) =>
                                        setFilterCategory(e.target.value)
                                    }>
                                    <option value=''>Select Category</option>
                                    {Object.keys(categoryList).length > 0 &&
                                        Object.values(categoryList).map(
                                            (category) => {
                                                return (
                                                    <option
                                                        key={
                                                            category.categoryId
                                                        }
                                                        value={
                                                            category.categoryId
                                                        }>
                                                        {category.title}
                                                    </option>
                                                );
                                            }
                                        )}
                                </select>
                            </div>
                        </div>
                        <div className='filter-buttons'>
                            <button
                                className='btn primary-button filter-button'
                                onClick={() => applyFilter()}>
                                Apply
                            </button>
                            <button
                                className='btn outline-button filter-button'
                                onClick={() => clearFilter()}>
                                Clear
                            </button>
                        </div>
                    </div>
                )}
                <ReportTable />
                {Object.keys(reportDetails).length > 0 && !fetchingReport && (
                    <div className='d-flex justify-content-between'>
                        <div className='d-flex align-items-center' style={{ paddingRight: 0 }}>
                            <div className='smallFont secondaryColor mx-2'>Show Entries</div>
                            <div className=''>
                                <select
                                    className="form-select postNoticeInput rounded"
                                    aria-label="Default select example"
                                    value={pagination.limit}
                                    onChange={(e) => setShowResult(e)}
                                    style={{ border: '1px solid gray', outline: 'none' }}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="40">40</option>
                                    <option value="100">100</option>
                                    <option value="250">250</option>
                                </select>
                            </div>
                            &nbsp;&nbsp;

                        </div>
                        <div className='paginationContainer1'>
                            <Pagination
                                activePage={pagination.pageIndex}
                                itemsCountPerPage={pagination.limit}
                                totalItemsCount={reportCount}
                                pageRangeDisplayed={3}
                                onChange={(num) => updateReportPagination(num)}
                            />
                        </div>
                        <div className='mt-2' style={{ fontSize: 'smaller' }} >
                            Total records: {reportCount}
                        </div>
                    </div>
                )}
            </div>
            {returnExportAllConfirmation()}
            {
                successModalDetails.successModal &&
                <SuccessModal
                    successModal={successModalDetails.successModal}
                    successModalType={successModalDetails.successModalType}
                    successMessage={successModalDetails.successMessage}
                    closeSuccessModal={closeSuccessModal}
                />
            }
        </>
    );
}

export default SemesterNoticeList;
